export const SET_FILES_SORT_PARAMS = 'SET_FILES_PARAMS';
export const SET_COLLECTIONS_SORT_PARAMS = 'SET_COLLECTIONS_PARAMS';

export const setFilesSortParams = params => ({
  type: SET_FILES_SORT_PARAMS,
  params,
});

export const setCollectionsSortParams = params => ({
  type: SET_COLLECTIONS_SORT_PARAMS,
  params,
});
